import { render, staticRenderFns } from "./header2.vue?vue&type=template&id=420ca425&scoped=true&"
import script from "./header2.vue?vue&type=script&lang=js&"
export * from "./header2.vue?vue&type=script&lang=js&"
import style0 from "./header2.vue?vue&type=style&index=0&id=420ca425&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "420ca425",
  null
  
)

export default component.exports